// hooks/useDernierAcces.js
import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import axiosInstance from '../variables/api/axiosInstance';

const ROUTES_PAR_TYPE = {
    CONTRAT: (codeId) => ({ path: `/details-contrat/${codeId}`, state: null }),
    SINISTRE: (codeId) => ({ path: '/details-sinistre/v2', state: { codeId } }),
    CESSION: (codeId) => ({ path: '/details-cession', state: { codeId } }),
    // Ajouter un nouveau type ici uniquement
};

export function useDernierAcces() {
    const navigate = useNavigate();
    const [dernierAcces, setDernierAcces] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        axiosInstance.get(`/api/dernier-acces/last`)
            .then(res => setDernierAcces(res.status === 204 ? null : res.data))
            .catch(() => setDernierAcces(null))
            .finally(() => setLoading(false));
    }, []);

    const reprendre = useCallback(() => {
        if (!dernierAcces) return;
        const route = ROUTES_PAR_TYPE[dernierAcces.typeEntite]?.(dernierAcces.entiteCodeId);
        if (!route) return;
        navigate(route.path, { replace: true, ...(route.state && { state: route.state }) });
    }, [dernierAcces, navigate]);

    return { dernierAcces, loading, reprendre };
}